import React from "react";
import { Routes, Route } from "react-router-dom";
import Homepage from "./Home";
import Login from "./Login";

export default function Main() {
  return <Homepage />;
}
